/**
 * UI-41 — la zone tactile de 44 px (WCAG 2.5.8), étendue par pseudo-élément
 * SANS toucher au diamètre peint : le design system choisit ses tailles, un
 * cercle de 32 reste un cercle de 32. Le pseudo-élément appartient au bouton,
 * donc un doigt qui vise à côté déclenche quand même.
 *
 * Ces deux recettes existaient en trois exemplaires — `button.tsx`,
 * `icon-button.tsx`, `tabs.tsx`. Trois copies, c'est trois occasions d'en
 * corriger deux.
 *
 * `HIT_Y` étend en hauteur seule : pour un contrôle déjà large, élargir
 * empiéterait sur son voisin. `HIT_SQUARE` étend dans les deux sens, pour ce
 * qui est carré et petit.
 */
export const HIT_Y =
  "after:absolute after:inset-x-0 after:top-1/2 after:h-11 after:-translate-y-1/2 after:content-['']";

export const HIT_SQUARE =
  "after:absolute after:top-1/2 after:left-1/2 after:size-11 after:-translate-x-1/2 after:-translate-y-1/2 after:content-['']";
